﻿let Q = require('q');

module.exports = {
    cache: {
        set: function (year, month, events) {
            if (!this[year]) {
                this[year] = {};
            }
            this[year][month] = events;
            return events
        },
    },

    getEventsForMonth: function (year, month) {
        if (this.cache[year] && this.cache[year][month]) {
            return Q.fcall(() =>this.cache[year][month]);
        } else {
            return this.fetchApiEventsForMonth(year, month)
                .then(events => this.cache.set(year, month, events))
        }
    },

    getUpcomingEvents: function (count, region) {
        return this.fetchApiUpcomingEvents(count, region);
    },

    fetchApiEventsForMonth: function (year, month) {
        return Q(
            jQuery.ajax({
                url: jnfroutesconfg.EventsApi,
                data: {
                    month: month,
                    year: year
                }
            })
        );
    },

    fetchApiUpcomingEvents: function(count, region) {
        return Q(
            jQuery.ajax({
                url: jnfroutesconfg.UpcomingEventsApi,
                data: {
                    count: count,
                    region: region
                }
            })
        );
    }
}